(ns ui.view.card.counterparty-diligence-docs.event
  (:require
   [re-frame.core :as rf]
   [ui.view.card.model :as common-model]
   [ui.view.counterparty-diligence.pdf-util :as pdf-util]
   [common.schema.entities.counterparty-diligence.templates.registry :as cd-template-registry]
   [common.localization :as loc]
   [frontend.state.current-session :as session]))

(rf/reg-fx
 ::open-answers-pdf
 (fn [{:keys [answers template attachments work-in-progress?]}]
   (let [date-format (or (:tenant/date-format @session/tenant)
                         (loc/tr :date-format))]
     (pdf-util/create-and-open-pdf {:answers answers
                                    :template template
                                    :date-format date-format
                                    :attachments attachments
                                    :work-in-progress? work-in-progress?}))))

(rf/reg-event-fx
 ::open-answers-pdf
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [entity-id card-state-path]}]]
   (let [entities (common-model/get-entities db card-state-path)
         counterparty-diligence (get entities entity-id)
         latest-process (->> counterparty-diligence
                             :counterparty-diligence/processes
                             (map (fn [process-id]
                                    (get entities process-id)))
                             (sort-by :common/created-on)
                             (filterv boolean)
                             last)
         latest-process-status (:counterparty-diligence-process/status latest-process)

         work-in-progress? (some #{latest-process-status}
                                 [:counterparty-diligence-process.status/draft
                                  :counterparty-diligence-process.status/sent-to-responders])
         template (cd-template-registry/resolve-template counterparty-diligence)
         answers (:counterparty-diligence-process/answers latest-process)]
     {::open-answers-pdf {:answers answers
                          :template template
                          :attachments entities
                          :work-in-progress? work-in-progress?}})))

